import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next';

import React, { Component } from 'react'
import Slider from "react-slick"

import { throttle, isMobile, equalHeight } from "../../utilities/FrontFunctions/AoxGlobalFrontFunctions"
import ObjPushCardFormation from './ObjPushCardFormation';

import '../../assets/css/0020_objects/0820_obj_produits_associes_comptoir_dermato.css';
import '../../assets/css/0020_objects/0621_obj_carrousel_slider.css'


class ObjProduitsAssociesComptoirDermato extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isMobile: isMobile()
		}
		this.handleWindowResizeMainHeader = this.handleWindowResizeMainHeader.bind(this)
		this.throttleWindowResizeMainHeader = throttle(this.handleWindowResizeMainHeader, 200)
		this.handleButtonFav = this.props.handleButtonFav.bind(this)
	}
	handleWindowResizeMainHeader() {
		this.setState({
			isMobile: isMobile()
		})
		this.applyEqualHeight()
	}

	componentDidMount() {
		this.applyEqualHeight();
		window.addEventListener('resize', this.throttleWindowResizeMainHeader)
    }
    componentWillUnmount() {
		window.removeEventListener('resize', this.throttleWindowResizeMainHeader)
		window.removeEventListener('scroll', this.throttleWindowScrollMainHeader)
	}
	applyEqualHeight() {
		setTimeout(() => {
			equalHeight(".obj_produits_associes_comptoir_dermato .obj_push_card .ctn_text_card");
		});
	}
    
    onSwipe() {
        if (this.slider) {
          	this.slider.innerSlider.clickable = true;
        }
	}

	render() {
        const { datasTrainings } = this.props;

		const sliderRef = slider => {this.slider = slider}
        const settings = {
            className: "obj_carousel_formation obj_carrousel_slider",
            centerMode: false,
			infinite: false,
			slidesToShow: 3,
            swipeToSlide: true,
            onSwipe: this.onSwipe.bind(this),
            dots: false,
            dotsClass: "slider-nav",
            appendDots: dots => (
                <div className="slider-nav" >
                    <ul> {dots} </ul>
                </div>
            ),
            arrows: true,
            speed: 750,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        centerPadding: "10%",
                        centerMode: true,
                        slidesToShow: 1,
                        dots: true,
                        arrows: false,
                    }
                }
            ]
        }

		return (<>{datasTrainings && <>
			<div className="obj_produits_associes_comptoir_dermato">
				<div className="ctn_title">
					<h3 className="t_title">Produits associés</h3>
				</div>

				<div className="ctn_carrousel">
					<Slider {...settings} ref={sliderRef}>
                        {datasTrainings.map((datasTraining, index) => (
                            <div className="item" key={index} >
                                <ObjPushCardFormation typeofPush="Formation" datasTraining={datasTraining} handleButtonFav={this.handleButtonFav}/>
                            </div>
                        ))}
                    </Slider>
				</div>
				
			</div>
        </>}</>)
	}

}

export default withTranslation()(withSitecoreContext()(ObjProduitsAssociesComptoirDermato));